export enum AccountTypeEnum {
  Internal = 1,
  External = 2
}
